module.exports = __webpack_public_path__ + "img/jscc-logo.697ff321.jpg";